// source: gifts_entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var coins_entity_pb = require('./coins_entity_pb.js');
goog.object.extend(proto, coins_entity_pb);
goog.exportSymbol('proto.jp.singcolor.Gift', null, global);
goog.exportSymbol('proto.jp.singcolor.Gift.BigGiftCoinAmount', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftDynamicPriceNotice', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftKind', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftTab', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftTabSection', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftTabSectionType', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftTabType', null, global);
goog.exportSymbol('proto.jp.singcolor.GiftType', null, global);
goog.exportSymbol('proto.jp.singcolor.SmallGiftType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.GiftDynamicPriceNotice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.GiftDynamicPriceNotice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.GiftDynamicPriceNotice.displayName = 'proto.jp.singcolor.GiftDynamicPriceNotice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Gift = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.Gift.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.Gift, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Gift.displayName = 'proto.jp.singcolor.Gift';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Gift.BigGiftCoinAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Gift.BigGiftCoinAmount.displayName = 'proto.jp.singcolor.Gift.BigGiftCoinAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.GiftTab = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.GiftTab.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.GiftTab, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.GiftTab.displayName = 'proto.jp.singcolor.GiftTab';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.GiftTabSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.GiftTabSection.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.GiftTabSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.GiftTabSection.displayName = 'proto.jp.singcolor.GiftTabSection';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.GiftDynamicPriceNotice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.GiftDynamicPriceNotice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftDynamicPriceNotice.toObject = function(includeInstance, msg) {
  var f, obj = {
    trayMessage: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bubbleMessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.GiftDynamicPriceNotice}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.GiftDynamicPriceNotice;
  return proto.jp.singcolor.GiftDynamicPriceNotice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.GiftDynamicPriceNotice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.GiftDynamicPriceNotice}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrayMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBubbleMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.GiftDynamicPriceNotice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.GiftDynamicPriceNotice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftDynamicPriceNotice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrayMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBubbleMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string tray_message = 1;
 * @return {string}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.getTrayMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.GiftDynamicPriceNotice} returns this
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.setTrayMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bubble_message = 2;
 * @return {string}
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.getBubbleMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.GiftDynamicPriceNotice} returns this
 */
proto.jp.singcolor.GiftDynamicPriceNotice.prototype.setBubbleMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.Gift.repeatedFields_ = [16,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Gift.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Gift.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Gift} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Gift.toObject = function(includeInstance, msg) {
  var f, obj = {
    giftId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    giftKind: jspb.Message.getFieldWithDefault(msg, 18, 0),
    giftType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    kana: jspb.Message.getFieldWithDefault(msg, 15, ""),
    suggestionWordsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    suggestionSubWordsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    coinAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    coin: (f = msg.getCoin()) && coins_entity_pb.CoinAmount.toObject(includeInstance, f),
    coinAmountBigGift: (f = msg.getCoinAmountBigGift()) && proto.jp.singcolor.Gift.BigGiftCoinAmount.toObject(includeInstance, f),
    chainable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    assetPath: jspb.Message.getFieldWithDefault(msg, 6, ""),
    thumbnailPath: jspb.Message.getFieldWithDefault(msg, 7, ""),
    assetHash: jspb.Message.getFieldWithDefault(msg, 10, ""),
    thumbnailHash: jspb.Message.getFieldWithDefault(msg, 11, ""),
    downloadPriority: jspb.Message.getFieldWithDefault(msg, 12, 0),
    appBundle: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    isOnePhraseStamp: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    dynamicCoinAmount: (f = msg.getDynamicCoinAmount()) && coins_entity_pb.CoinAmount.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Gift}
 */
proto.jp.singcolor.Gift.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Gift;
  return proto.jp.singcolor.Gift.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Gift} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Gift}
 */
proto.jp.singcolor.Gift.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGiftId(value);
      break;
    case 18:
      var value = /** @type {!proto.jp.singcolor.GiftKind} */ (reader.readEnum());
      msg.setGiftKind(value);
      break;
    case 2:
      var value = /** @type {!proto.jp.singcolor.GiftType} */ (reader.readEnum());
      msg.setGiftType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setKana(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestionWords(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestionSubWords(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCoinAmount(value);
      break;
    case 19:
      var value = new coins_entity_pb.CoinAmount;
      reader.readMessage(value,coins_entity_pb.CoinAmount.deserializeBinaryFromReader);
      msg.setCoin(value);
      break;
    case 14:
      var value = new proto.jp.singcolor.Gift.BigGiftCoinAmount;
      reader.readMessage(value,proto.jp.singcolor.Gift.BigGiftCoinAmount.deserializeBinaryFromReader);
      msg.setCoinAmountBigGift(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChainable(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetPath(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailPath(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetHash(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailHash(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDownloadPriority(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAppBundle(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOnePhraseStamp(value);
      break;
    case 21:
      var value = new coins_entity_pb.CoinAmount;
      reader.readMessage(value,coins_entity_pb.CoinAmount.deserializeBinaryFromReader);
      msg.setDynamicCoinAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Gift.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Gift.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Gift} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Gift.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGiftId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGiftKind();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getGiftType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getKana();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSuggestionWordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getSuggestionSubWordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getCoinAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCoin();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      coins_entity_pb.CoinAmount.serializeBinaryToWriter
    );
  }
  f = message.getCoinAmountBigGift();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.jp.singcolor.Gift.BigGiftCoinAmount.serializeBinaryToWriter
    );
  }
  f = message.getChainable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAssetPath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getThumbnailPath();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssetHash();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getThumbnailHash();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDownloadPriority();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAppBundle();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getIsOnePhraseStamp();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getDynamicCoinAmount();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      coins_entity_pb.CoinAmount.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Gift.BigGiftCoinAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Gift.BigGiftCoinAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    coinAmountBig: jspb.Message.getFieldWithDefault(msg, 1, 0),
    coinBig: (f = msg.getCoinBig()) && coins_entity_pb.CoinAmount.toObject(includeInstance, f),
    coinAmountBigHeart: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coinBigHeart: (f = msg.getCoinBigHeart()) && coins_entity_pb.CoinAmount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Gift.BigGiftCoinAmount;
  return proto.jp.singcolor.Gift.BigGiftCoinAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Gift.BigGiftCoinAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCoinAmountBig(value);
      break;
    case 3:
      var value = new coins_entity_pb.CoinAmount;
      reader.readMessage(value,coins_entity_pb.CoinAmount.deserializeBinaryFromReader);
      msg.setCoinBig(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCoinAmountBigHeart(value);
      break;
    case 4:
      var value = new coins_entity_pb.CoinAmount;
      reader.readMessage(value,coins_entity_pb.CoinAmount.deserializeBinaryFromReader);
      msg.setCoinBigHeart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Gift.BigGiftCoinAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Gift.BigGiftCoinAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCoinAmountBig();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCoinBig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      coins_entity_pb.CoinAmount.serializeBinaryToWriter
    );
  }
  f = message.getCoinAmountBigHeart();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCoinBigHeart();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      coins_entity_pb.CoinAmount.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 coin_amount_big = 1;
 * @return {number}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.getCoinAmountBig = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.setCoinAmountBig = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CoinAmount coin_big = 3;
 * @return {?proto.jp.singcolor.CoinAmount}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.getCoinBig = function() {
  return /** @type{?proto.jp.singcolor.CoinAmount} */ (
    jspb.Message.getWrapperField(this, coins_entity_pb.CoinAmount, 3));
};


/**
 * @param {?proto.jp.singcolor.CoinAmount|undefined} value
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
*/
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.setCoinBig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.clearCoinBig = function() {
  return this.setCoinBig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.hasCoinBig = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 coin_amount_big_heart = 2;
 * @return {number}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.getCoinAmountBigHeart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.setCoinAmountBigHeart = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CoinAmount coin_big_heart = 4;
 * @return {?proto.jp.singcolor.CoinAmount}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.getCoinBigHeart = function() {
  return /** @type{?proto.jp.singcolor.CoinAmount} */ (
    jspb.Message.getWrapperField(this, coins_entity_pb.CoinAmount, 4));
};


/**
 * @param {?proto.jp.singcolor.CoinAmount|undefined} value
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
*/
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.setCoinBigHeart = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Gift.BigGiftCoinAmount} returns this
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.clearCoinBigHeart = function() {
  return this.setCoinBigHeart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Gift.BigGiftCoinAmount.prototype.hasCoinBigHeart = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string gift_id = 1;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getGiftId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setGiftId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GiftKind gift_kind = 18;
 * @return {!proto.jp.singcolor.GiftKind}
 */
proto.jp.singcolor.Gift.prototype.getGiftKind = function() {
  return /** @type {!proto.jp.singcolor.GiftKind} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.jp.singcolor.GiftKind} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setGiftKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional GiftType gift_type = 2;
 * @return {!proto.jp.singcolor.GiftType}
 */
proto.jp.singcolor.Gift.prototype.getGiftType = function() {
  return /** @type {!proto.jp.singcolor.GiftType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.jp.singcolor.GiftType} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setGiftType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string kana = 15;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getKana = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setKana = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string suggestion_words = 16;
 * @return {!Array<string>}
 */
proto.jp.singcolor.Gift.prototype.getSuggestionWordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setSuggestionWordsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.addSuggestionWords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.clearSuggestionWordsList = function() {
  return this.setSuggestionWordsList([]);
};


/**
 * repeated string suggestion_sub_words = 17;
 * @return {!Array<string>}
 */
proto.jp.singcolor.Gift.prototype.getSuggestionSubWordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setSuggestionSubWordsList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.addSuggestionSubWords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.clearSuggestionSubWordsList = function() {
  return this.setSuggestionSubWordsList([]);
};


/**
 * optional int64 coin_amount = 4;
 * @return {number}
 */
proto.jp.singcolor.Gift.prototype.getCoinAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setCoinAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional CoinAmount coin = 19;
 * @return {?proto.jp.singcolor.CoinAmount}
 */
proto.jp.singcolor.Gift.prototype.getCoin = function() {
  return /** @type{?proto.jp.singcolor.CoinAmount} */ (
    jspb.Message.getWrapperField(this, coins_entity_pb.CoinAmount, 19));
};


/**
 * @param {?proto.jp.singcolor.CoinAmount|undefined} value
 * @return {!proto.jp.singcolor.Gift} returns this
*/
proto.jp.singcolor.Gift.prototype.setCoin = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.clearCoin = function() {
  return this.setCoin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.hasCoin = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional BigGiftCoinAmount coin_amount_big_gift = 14;
 * @return {?proto.jp.singcolor.Gift.BigGiftCoinAmount}
 */
proto.jp.singcolor.Gift.prototype.getCoinAmountBigGift = function() {
  return /** @type{?proto.jp.singcolor.Gift.BigGiftCoinAmount} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.Gift.BigGiftCoinAmount, 14));
};


/**
 * @param {?proto.jp.singcolor.Gift.BigGiftCoinAmount|undefined} value
 * @return {!proto.jp.singcolor.Gift} returns this
*/
proto.jp.singcolor.Gift.prototype.setCoinAmountBigGift = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.clearCoinAmountBigGift = function() {
  return this.setCoinAmountBigGift(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.hasCoinAmountBigGift = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool chainable = 5;
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.getChainable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setChainable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string asset_path = 6;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getAssetPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setAssetPath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string thumbnail_path = 7;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getThumbnailPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setThumbnailPath = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string asset_hash = 10;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getAssetHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setAssetHash = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string thumbnail_hash = 11;
 * @return {string}
 */
proto.jp.singcolor.Gift.prototype.getThumbnailHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setThumbnailHash = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 download_priority = 12;
 * @return {number}
 */
proto.jp.singcolor.Gift.prototype.getDownloadPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setDownloadPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool app_bundle = 13;
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.getAppBundle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setAppBundle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool is_one_phrase_stamp = 20;
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.getIsOnePhraseStamp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setIsOnePhraseStamp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional CoinAmount dynamic_coin_amount = 21;
 * @return {?proto.jp.singcolor.CoinAmount}
 */
proto.jp.singcolor.Gift.prototype.getDynamicCoinAmount = function() {
  return /** @type{?proto.jp.singcolor.CoinAmount} */ (
    jspb.Message.getWrapperField(this, coins_entity_pb.CoinAmount, 21));
};


/**
 * @param {?proto.jp.singcolor.CoinAmount|undefined} value
 * @return {!proto.jp.singcolor.Gift} returns this
*/
proto.jp.singcolor.Gift.prototype.setDynamicCoinAmount = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.clearDynamicCoinAmount = function() {
  return this.setDynamicCoinAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Gift.prototype.hasDynamicCoinAmount = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.jp.singcolor.Gift.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 updated_at = 9;
 * @return {number}
 */
proto.jp.singcolor.Gift.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Gift} returns this
 */
proto.jp.singcolor.Gift.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.GiftTab.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.GiftTab.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.GiftTab.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.GiftTab} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftTab.toObject = function(includeInstance, msg) {
  var f, obj = {
    giftTabType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isdefault: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    normalorderindex: jspb.Message.getFieldWithDefault(msg, 5, 0),
    singingorderindex: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.jp.singcolor.GiftTabSection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.GiftTab}
 */
proto.jp.singcolor.GiftTab.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.GiftTab;
  return proto.jp.singcolor.GiftTab.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.GiftTab} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.GiftTab}
 */
proto.jp.singcolor.GiftTab.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.jp.singcolor.GiftTabType} */ (reader.readEnum());
      msg.setGiftTabType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdefault(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNormalorderindex(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSingingorderindex(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.GiftTabSection;
      reader.readMessage(value,proto.jp.singcolor.GiftTabSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.GiftTab.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.GiftTab.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.GiftTab} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftTab.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGiftTabType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsdefault();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNormalorderindex();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSingingorderindex();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.jp.singcolor.GiftTabSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional GiftTabType gift_tab_type = 1;
 * @return {!proto.jp.singcolor.GiftTabType}
 */
proto.jp.singcolor.GiftTab.prototype.getGiftTabType = function() {
  return /** @type {!proto.jp.singcolor.GiftTabType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.jp.singcolor.GiftTabType} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.setGiftTabType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.GiftTab.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isDefault = 4;
 * @return {boolean}
 */
proto.jp.singcolor.GiftTab.prototype.getIsdefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.setIsdefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 normalOrderIndex = 5;
 * @return {number}
 */
proto.jp.singcolor.GiftTab.prototype.getNormalorderindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.setNormalorderindex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 singingOrderIndex = 6;
 * @return {number}
 */
proto.jp.singcolor.GiftTab.prototype.getSingingorderindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.setSingingorderindex = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated GiftTabSection sections = 3;
 * @return {!Array<!proto.jp.singcolor.GiftTabSection>}
 */
proto.jp.singcolor.GiftTab.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.jp.singcolor.GiftTabSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.GiftTabSection, 3));
};


/**
 * @param {!Array<!proto.jp.singcolor.GiftTabSection>} value
 * @return {!proto.jp.singcolor.GiftTab} returns this
*/
proto.jp.singcolor.GiftTab.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.jp.singcolor.GiftTabSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.GiftTabSection}
 */
proto.jp.singcolor.GiftTab.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.jp.singcolor.GiftTabSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.GiftTab} returns this
 */
proto.jp.singcolor.GiftTab.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.GiftTabSection.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.GiftTabSection.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.GiftTabSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.GiftTabSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftTabSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    giftTabSectionType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    giftsList: jspb.Message.toObjectList(msg.getGiftsList(),
    proto.jp.singcolor.Gift.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.GiftTabSection}
 */
proto.jp.singcolor.GiftTabSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.GiftTabSection;
  return proto.jp.singcolor.GiftTabSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.GiftTabSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.GiftTabSection}
 */
proto.jp.singcolor.GiftTabSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.jp.singcolor.GiftTabSectionType} */ (reader.readEnum());
      msg.setGiftTabSectionType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.Gift;
      reader.readMessage(value,proto.jp.singcolor.Gift.deserializeBinaryFromReader);
      msg.addGifts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.GiftTabSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.GiftTabSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.GiftTabSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.GiftTabSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGiftTabSectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGiftsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.jp.singcolor.Gift.serializeBinaryToWriter
    );
  }
};


/**
 * optional GiftTabSectionType gift_tab_section_type = 1;
 * @return {!proto.jp.singcolor.GiftTabSectionType}
 */
proto.jp.singcolor.GiftTabSection.prototype.getGiftTabSectionType = function() {
  return /** @type {!proto.jp.singcolor.GiftTabSectionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.jp.singcolor.GiftTabSectionType} value
 * @return {!proto.jp.singcolor.GiftTabSection} returns this
 */
proto.jp.singcolor.GiftTabSection.prototype.setGiftTabSectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.GiftTabSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.GiftTabSection} returns this
 */
proto.jp.singcolor.GiftTabSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Gift gifts = 3;
 * @return {!Array<!proto.jp.singcolor.Gift>}
 */
proto.jp.singcolor.GiftTabSection.prototype.getGiftsList = function() {
  return /** @type{!Array<!proto.jp.singcolor.Gift>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.Gift, 3));
};


/**
 * @param {!Array<!proto.jp.singcolor.Gift>} value
 * @return {!proto.jp.singcolor.GiftTabSection} returns this
*/
proto.jp.singcolor.GiftTabSection.prototype.setGiftsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.jp.singcolor.Gift=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.Gift}
 */
proto.jp.singcolor.GiftTabSection.prototype.addGifts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.jp.singcolor.Gift, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.GiftTabSection} returns this
 */
proto.jp.singcolor.GiftTabSection.prototype.clearGiftsList = function() {
  return this.setGiftsList([]);
};


/**
 * @enum {number}
 */
proto.jp.singcolor.GiftKind = {
  GIFT_KIND_NORMAL: 0,
  GIFT_KIND_REACTION: 1,
  GIFT_KIND_GOSPEL_REACTION: 2
};

/**
 * @enum {number}
 */
proto.jp.singcolor.GiftType = {
  GIFT_TYPE_UNKNOWN: 0,
  GIFT_TYPE_SMALL: 1,
  GIFT_TYPE_MIDDLE: 2,
  GIFT_TYPE_LARGE: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.SmallGiftType = {
  SMALL_GIFT_TYPE_UNKNOWN: 0,
  SMALL_GIFT_TYPE_DEFAULT: 1,
  SMALL_GIFT_TYPE_BIG: 2,
  SMALL_GIFT_TYPE_BIG_HEART: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.GiftTabType = {
  GIFT_TAB_TYPE_UNKNOWN: 0,
  GIFT_TAB_TYPE_HOME: 1,
  GIFT_TAB_TYPE_KANA: 2,
  GIFT_TAB_TYPE_PRICE: 3,
  GIFT_TAB_TYPE_CATEGORY: 4,
  GIFT_TAB_TYPE_NEW: 5
};

/**
 * @enum {number}
 */
proto.jp.singcolor.GiftTabSectionType = {
  GIFT_TAB_SECTION_TYPE_UNKNOWN: 0,
  GIFT_TAB_SECTION_TYPE_ALL: 1,
  GIFT_TAB_SECTION_TYPE_RECOMMEND: 2,
  GIFT_TAB_SECTION_TYPE_HISTORY: 3,
  GIFT_TAB_SECTION_TYPE_USE_FREQUENTLY_S: 4,
  GIFT_TAB_SECTION_TYPE_POPULAR_S: 5,
  GIFT_TAB_SECTION_TYPE_USE_FREQUENTLY_ML: 6,
  GIFT_TAB_SECTION_TYPE_POPULAR_ML: 7,
  GIFT_TAB_SECTION_TYPE_KANA_S: 8,
  GIFT_TAB_SECTION_TYPE_KANA_M: 9,
  GIFT_TAB_SECTION_TYPE_KANA_L: 10,
  GIFT_TAB_SECTION_TYPE_PRICE: 11
};

goog.object.extend(exports, proto.jp.singcolor);
